module.exports = __webpack_public_path__ + "static/media/pills.3fd95875.png";